import { toast } from "react-toastify";
import { GetAllGatepassApi } from "../../../Api/Store/Gatepass";

export const GetAllGatepass = (data) => {
  return {
    type: "get_all_gatepass",
    payload: data,
    loader: false,
  };
};

export function getallGatepass(projectId) {
  return async (dispatch) => {
    try {
      const result = await GetAllGatepassApi(projectId);

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllGatepass(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch gate passes");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching gate passes!");
    }
  };
}
